export default __webpack_public_path__ + "static/media/img5.3830766a.png";